import {api, headers} from './api';

const RESOURCE = 'mahasiswa';

export const getsMahasiswa = (prodi, tahun) => api.get(`${RESOURCE}?prodi=${prodi}&tahun=${tahun}`, headers);

export const searchMahasiswa = (keyword) => api.get(`${RESOURCE}/search?keyword=${keyword}`, headers);